import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.816",
  height: "11.404"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "data-name": "ptaszek do linka" }, [
      _createElementVNode("path", {
        fill: "none",
        stroke: "#626997",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "m1.413 5.156 4.933 5.248 7.067-9",
        "data-name": "Path 16166"
      })
    ], -1)
  ]))]))
}
export default { render: render }